export const CV_STATUS = {
  PUBLISH: 'publish',
  DRAFT: 'draft',
  INVITED: 'invited',
  DELETED: 'deleted',
  NOT_INVITED: 'not_invited', // default status, not stored, for scrapped-only profiles.
};
